/**
 * Display Types - Centralized display type definitions
 * PageBuilder component'inde kullanılan tüm display type'ları merkezi olarak tanımlar
 */

export const DISPLAY_TYPES = {
  COMPONENT: 'component',
  LIST: 'list',
  SWIPER: 'swiper',
  TAB: 'tab',
  TAB_SWIPER: 'tab-swiper',
  FAQ: 'faq',
  EXPANDABLE_TEXT: 'expandable-text'
};




export default DISPLAY_TYPES;
